import { oneLine } from 'common-tags/es';

const data = {
    type: 'homepage',
    path: '/',
    title: 'The dream',
    content: [
        oneLine`Every child in Aotearoa New Zealand <br class="hidden md+:inline" />deserves to have the opportunity 
            and support <br class="hidden md+:inline" />they need to live a good life.`,
        oneLine`Aotearoa New Zealand has the potential <br class="hidden md+:inline" />to be a country where all 
            children and young people thrive,<br class="hidden md+:inline" /> with strong whānau and connected 
            communities.`,
    ],
    meta: {
        title: 'Tracking progress on reducing child poverty in New Zealand | Child Poverty',
    },
    tilesGroups: [
        {
            name: 'first-tile-group',
            first: true,
            heading: oneLine`Are we closer to eliminating <br class="hidden sm:inline" /> child poverty in Aotearoa?`,
            subheading: oneLine`Click the hotspots to explore our community.`,
            animations: [
                {
                    filename: 'cloud-5.png',
                    type: 'css',
                    width: '15%',
                    top: '10%',
                    left: '3%',
                    mobileWidth: '45%',
                    mobileTop: '10%',
                    mobileLeft: '-20%',
                    animation: '5s linear infinite bob-1',
                },
                {
                    filename: 'cloud-2.png',
                    type: 'css',
                    width: '20%',
                    top: '-10%',
                    left: '80%',
                    mobileWidth: '50%',
                    mobileTop: '0%',
                    mobileLeft: '80%',
                    animation: '5s linear 1s infinite bob-2',
                },
                {
                    filename: 'cloud-6.png',
                    type: 'css',
                    width: '15%',
                    top: '30%',
                    left: '80%',
                    mobileWidth: '50%',
                    mobileTop: '40%',
                    mobileLeft: '80%',
                    animation: '5s linear infinite bob-2',
                },
                {
                    filename: 'cloud-3.png',
                    type: 'css',
                    width: '15%',
                    top: '45%',
                    left: '-10%',
                    mobileWidth: '55%',
                    mobileTop: '40%',
                    mobileLeft: '-40%',
                    animation: '5s linear 3s infinite bob-1',
                },
                {
                    filename: 'cloud-2.png',
                    type: 'css',
                    width: '20%',
                    top: '60%',
                    left: '90%',
                    mobileWidth: '50%',
                    mobileTop: '60%',
                    mobileLeft: '90%',
                    animation: '5s linear 2s infinite bob-2',
                },
                {
                    filename: 'cloud-7.png',
                    type: 'css',
                    width: '15%',
                    top: '80%',
                    left: '3%',
                    mobileWidth: '40%',
                    mobileTop: '82%',
                    mobileLeft: '-25%',
                    animation: '5s linear infinite bob-1',
                },
                {
                    filename: 'cloud-10.png',
                    type: 'css',
                    width: '10%',
                    top: '90%',
                    left: '83%',
                    mobileWidth: '25%',
                    mobileTop: '90%',
                    mobileLeft: '90%',
                    animation: '5s linear infinite bob-2',
                },
            ],
            tiles: [
                {
                    filename: '1_Welcome.png',
                    mobileFilename: '1_Welcome_mobile.png',
                    animations: [
                        {
                            filename: '01 HEALTH - Tree.json',
                            type: 'lottie',
                            loop: true,
                            width: '15%',
                            top: '4%',
                            left: '58.5%',
                            mobileTop: '5%',
                            mobileLeft: '40%',
                        },
                    ],
                },
                {
                    filename: '2_Income.png',
                    mobileFilename: '2_Income_mobile.png',
                    animations: [
                        {
                            filename: '02 INCOME - Bird.json',
                            type: 'lottie',
                            loop: true,
                            width: '35%',
                            top: '5%',
                            left: '10%',
                            mobileTop: '5%',
                            mobileLeft: '20%',
                        },
                    ],
                    dialogs: [
                        {
                            title: 'Adequate income',
                            number: 1,
                            showTitle: true,
                            first: true,
                            position: 'bottom',
                            top: '10%',
                            left: '42%',
                            mobileTop: '16%',
                            mobileLeft: '55%',
                            content: oneLine`<b>254,000</b> children, or <b>23%</b>, live in low-income households. These 
                                are households that have disposable equivalised income less than 50% of the national 
                                median income after housing costs.`,
                            link: '/measures/income',
                        },
                        {
                            title: 'Adequate income',
                            number: 2,
                            position: 'top',
                            top: '33%',
                            left: '21%',
                            mobileTop: '40%',
                            mobileLeft: '27%',
                            content: oneLine`By 2028, the Government has committed to reduce the number of children in 
                                low-income households by <b>130,000</b> – from <b>23%</b> to <b>10%</b>.`,
                            link: '/measures/income',
                        },
                    ],
                },
                {
                    filename: '3_Essentials.png',
                    mobileFilename: '3_Essentials_mobile.png',
                    animations: [
                        {
                            filename: '03 ESSENTIALS - PersonJumping.json',
                            type: 'lottie',
                            loop: true,
                            width: '30%',
                            top: '38%',
                            left: '34%',
                            mobileTop: '26%',
                            mobileLeft: '26%',
                            noAnimateIE: true,
                        },
                    ],
                    dialogs: [
                        {
                            title: 'Access to essentials',
                            number: 3,
                            showTitle: true,
                            position: 'bottom',
                            top: '22%',
                            left: '47%',
                            mobileTop: '5%',
                            mobileLeft: '38%',
                            content: oneLine`<b>148,000</b> children, or <b>13%</b>, live in households experiencing 
                                material hardship, which means going without six or more essentials for a decent 
                                standard of living.`,
                            link: '/measures/essentials',
                        },
                        {
                            title: 'Access to essentials',
                            number: 4,
                            top: '47%',
                            left: '68%',
                            mobileTop: '38%',
                            mobileLeft: '65%',
                            content: oneLine`<b>65,000</b> children live in households experiencing severe material 
                                hardship, which means going without nine or more essentials for a decent standard of 
                                living.`,
                            link: '/measures/essentials',
                        },
                        {
                            title: 'Access to essentials',
                            number: 5,
                            top: '84%',
                            left: '25%',
                            mobileTop: '72%',
                            mobileLeft: '15%',
                            content: oneLine`By 2028, the Government has committed to reduce the number of children 
                                living in material hardship by <b>80,000</b> – from <b>13%</b> to <b>6%</b>.`,
                            link: '/measures/essentials',
                        },
                    ],
                },
                {
                    filename: '4_Health.png',
                    mobileFilename: '4_Health_mobile.png',
                    animations: [
                        {
                            filename: '04 HEALTH - Chopper.json',
                            type: 'lottie',
                            loop: true,
                            width: '35%',
                            top: '0%',
                            left: '30%',
                            mobileTop: '-10%',
                            mobileLeft: '38%',
                        },
                        {
                            filename: '04 HEALTH - Inhaler.json',
                            type: 'lottie',
                            loop: true,
                            width: '60%',
                            top: '45%',
                            left: '45%',
                            mobileTop: '41%',
                            mobileLeft: '52%',
                        },
                    ],
                    dialogs: [
                        {
                            title: 'Good health',
                            number: 6,
                            showTitle: true,
                            top: '70%',
                            left: '32%',
                            mobileTop: '67%',
                            mobileLeft: '38%',
                            content: oneLine`Children living in areas with the highest deprivation scores are 
                                <b>three times</b> more likely to end up in hospital than children in areas with the 
                                lowest deprivation scores.`,
                            link: '/measures/health',
                        },
                    ],
                },
                {
                    filename: '5_Home.png',
                    mobileFilename: '5_Home_mobile.png',
                    animations: [
                        {
                            filename: '05 HOME - Roof.json',
                            type: 'lottie',
                            loop: true,
                            width: '45%',
                            top: '10%',
                            left: '30%',
                            mobileTop: '10%',
                            mobileLeft: '25%',
                        },
                        {
                            filename: '05 HOME - Swing.json',
                            type: 'lottie',
                            loop: true,
                            width: '30%',
                            top: '27%',
                            left: '13%',
                            mobileTop: '27%',
                            mobileLeft: '8%',
                        },
                    ],
                    dialogs: [
                        {
                            title: 'A place to call home',
                            number: 7,
                            showTitle: true,
                            top: '74%',
                            left: '25%',
                            mobileTop: '72%',
                            mobileLeft: '13%',
                            content: oneLine`High housing costs contribute to many families living in poverty. More 
                                than <b>30%</b> of the lowest income households with children spend more than half of 
                                their income on housing costs.`,
                            link: '/measures/home',
                        },
                    ],
                },
                {
                    filename: '6_Food.png',
                    mobileFilename: '6_Food_mobile.png',
                    animations: [
                        {
                            filename: '06 FOOD - Trolley.json',
                            type: 'lottie',
                            loop: true,
                            width: '58%',
                            top: '10%',
                            left: '10%',
                            mobileTop: '2%',
                            mobileLeft: '24%',
                        },
                    ],
                    dialogs: [
                        {
                            title: 'Healthy food',
                            number: 8,
                            showTitle: true,
                            position: 'bottom',
                            top: '17%',
                            left: '49%',
                            mobileTop: '9%',
                            mobileLeft: '65%',
                            content: oneLine`<b>174,000</b> children live in households that can’t always afford to 
                                put enough healthy food on the table.`,
                            link: '/measures/food',
                        },
                        {
                            title: 'Healthy food',
                            number: 9,
                            top: '53%',
                            left: '0%',
                            mobileTop: '42%',
                            mobileLeft: '8%',
                            content: oneLine`<b>56%</b> of children living in families receiving financial assistance 
                                don't always have enough healthy food to eat, compared to just <b>12%</b> of children 
                                living in families not receiving financial assistance.`,
                            link: '/measures/food',
                        },
                    ],
                },
            ],
        },
        {
            name: 'second-tile-group',
            heading: 'What needs to change?',
            subheading: oneLine`Poverty continues to unfairly constrain the lives of too many children and their 
            families in New Zealand. Poverty limits opportunities and choices, and creates toxic stress that can make 
            daily life unbearable. It fractures relationships, undermines health and education, and can make it almost 
            impossible to get out of survival mode.`,
            animations: [
                {
                    filename: 'cloud-1.png',
                    type: 'css',
                    width: '15%',
                    top: '60%',
                    left: '3%',
                    mobileWidth: '50%',
                    mobileTop: '50%',
                    mobileLeft: '-30%',
                    animation: '5s linear infinite bob-1',
                },
                {
                    filename: 'cloud-5.png',
                    type: 'css',
                    width: '15%',
                    top: '10%',
                    left: '75%',
                    mobileWidth: '50%',
                    mobileTop: '-5%',
                    mobileLeft: '85%',
                    animation: '5s linear 0.5s infinite bob-1',
                },
                {
                    filename: 'cloud-4.png',
                    type: 'css',
                    width: '15%',
                    top: '15%',
                    left: '60%',
                    mobileWidth: '60%',
                    mobileTop: '35%',
                    mobileLeft: '80%',
                    animation: '5s linear infinite bob-1',
                },
            ],
            tiles: [
                {
                    filename: '7_Policy.png',
                    mobileFilename: '7_Policy_mobile.png',
                    animations: [
                        {
                            filename: '07 POLICY - ProtestorStanding.json',
                            type: 'lottie',
                            loop: true,
                            width: '15%',
                            top: '19%',
                            left: '12%',
                            mobileTop: '0%',
                            mobileLeft: '13%',
                        },
                        {
                            filename: '07 POLICY - ProtestorWheelchair.json',
                            type: 'lottie',
                            loop: true,
                            width: '18%',
                            top: '58%',
                            left: '30%',
                            mobileTop: '55%',
                            mobileLeft: '33%',
                        },
                    ],
                    dialogs: [
                        {
                            title: 'Policy',
                            number: 10,
                            showTitle: true,
                            position: 'bottom',
                            top: '18%',
                            left: '29%',
                            mobileTop: '5%',
                            mobileLeft: '29%',
                            content: oneLine`One of the best ways to reduce the number of children in poverty is to 
                                <b>raise family incomes</b> by increasing benefits and making the minimum wage a 
                                living wage.`,
                        },
                    ],
                },
                {
                    filename: '8_Future.png',
                    mobileFilename: '8_Future_mobile.png',
                    offset: '50%',
                    animations: [
                        {
                            filename: '08 FUTURE - Tree.json',
                            type: 'lottie',
                            loop: true,
                            width: '20%',
                            top: '12.4%',
                            left: '56.7%',
                            mobileTop: '10%',
                            mobileLeft: '57%',
                        },
                        {
                            filename: '08 FUTURE - Beachball.json',
                            type: 'lottie',
                            loop: true,
                            width: '35%',
                            top: '5%',
                            left: '12%',
                            mobileTop: '2%',
                            mobileLeft: '12%',
                            noAnimateIE: true,
                        },
                    ],
                    dialogs: [
                        {
                            title: 'Hope for the future',
                            number: 11,
                            showTitle: true,
                            position: 'bottom',
                            top: '5%',
                            left: '36%',
                            mobileTop: '-6%',
                            mobileLeft: '45%',
                            content: oneLine`Current and future Governments can invest more in solutions to unlock the
                                constraints of poverty. We can have a future that delivers freedom from poverty and 
                                sustainable well-being for all New Zealanders.`,
                        },
                    ],
                },
            ],
        },
        {
            name: 'third-tile-group',
            heading: 'About the Child Poverty Monitor',
            subheading: oneLine`The annual Child Poverty Monitor reports on <br class="hidden sm:inline" />child 
                poverty in New Zealand and its impacts. <br class="hidden sm:inline" />
                <a class="font-semibold underline-link" href="/about">Click to find out more</a>.`,
        },
    ],
};

export default data;
